export default __webpack_public_path__ + "media/zurb/img/playground/ux-metric-card-breakdown-0621c048b9cc55adb5e5ae2e5b42c6e3.png";